<template>
  <b-row v-show="!itsLoading">
    <b-col>
      <Breadcrumb
        :collection="breadcrumbCollection"
        @button-clicked="removeBreadCrumb(folderCode)"
      />
    </b-col>
    <b-col cols="12" class="d-flex justify-content-center">
      <img
        class="advertiser-logo"
        v-if="advertiser.length"
        :src="advertiser[0].url"
        alt=""
      />
    </b-col>
    <b-col cols="12" class="section-title p-3">
      <b-container class="d-flex" align-v="center">
        <img
          src="@/assets/folder_arrow.svg"
          alt="Material de apoio"
          slot="icon"
          class="card-icon"
        />
        <h5 class="mb-0 pb-0 ml-2">Material de Apoio {{ getFolderTittle }}</h5>
      </b-container>
    </b-col>
    <b-col>
      <b-container>
        <div id="input-search-container">
          <InputSearch
            :placeHolder="'Buscar pastas/arquivos'"
            @searchEvent="searchFilesAndFolders"
          />
        </div>

        <b-table-simple
          responsive
          borderless
          class="pt-1"
          cellspacing="0"
          cellpadding="0"
        >
          <b-thead>
            <b-tr>
              <b-th
                :class="'fields-th th-' + field.name"
                v-for="field in fields"
                :key="field.name"
              >
                <strong class="text-regular font-weight-bold">{{
                  field.name
                }}</strong>
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="tbody-files">
            <b-tr
              v-show="!showSearchError"
              v-for="file in pagedFiles"
              :key="file.idt"
              class="table-tr-files"
            >
              <b-td class="td-file-name-icon">
                <div class="d-flex align-items-center file-name-icon">
                  <img
                    v-show="
                      file.file_type === 'file' &&
                      (file.extension === 'png' ||
                        file.extension === 'jpg' ||
                        file.extension === 'jpeg')
                    "
                    class="folder-icon click-preview"
                    :src="file.signURL"
                    alt="miniatura"
                    height="28"
                    @click="openThumbnailModal(file)"
                  />
                  <img
                    v-show="
                      file.file_type === 'file' &&
                      file.extension !== 'png' &&
                      file.extension !== 'jpg' &&
                      file.extension !== 'jpeg'
                    "
                    class="folder-icon"
                    :src="getImgUrl(file.extension)"
                    :alt="'icone arquivo do tipo ' + file.extension"
                    height="28"
                  />
                  <img
                    v-show="file.file_type === 'folder'"
                    class="folder-icon"
                    src="@/assets/file_types/folder.svg"
                    alt="icone pasta"
                    height="22"
                  />
                  <span v-if="file.file_type === 'file'" class="text-regular">
                    {{
                      checkMobile(576)
                        ? nameFormatter(file.file_name)
                        : file.file_name
                    }}
                  </span>
                  <router-link
                    v-else
                    :to="
                      baseUrlFolder +
                      file.file_name.replace(/\s/g, '-') +
                      '/' +
                      file.idt
                    "
                    @click.native="setBreadCrumb(file.file_name, file.idt)"
                  >
                    <span class="text-regular">
                      {{
                        checkMobile(576)
                          ? nameFormatter(file.file_name)
                          : file.file_name
                      }}
                    </span>
                  </router-link>
                </div>
                <span class="modificado-text" v-if="checkMobile(768)">
                  Modificado {{ dateFormatter(file.created_at) }}
                </span>
              </b-td>
              <b-td class="td-modificado" v-if="!checkMobile(768)">
                <span class="text-regular">{{
                  dateFormatter(file.created_at)
                }}</span>
              </b-td>
              <b-td class="file-size">
                <span class="text-regular">{{ file.file_size || "0 KB" }}</span>
              </b-td>
              <b-td class="file-download">
                <a
                  href="#"
                  class="download-link"
                  @click.prevent="callZipFiles(file)"
                >
                  <img
                    src="@/assets/download.svg"
                    alt="download-icons"
                    class="download-icon"
                  />
                  <span class="text-regular" v-if="!checkMobile(768)"
                    >Download</span
                  >
                </a>
              </b-td>
            </b-tr>
            <b-tr v-show="showSearchError">
              <b-td colspan="4">
                <div class="search-error-wrapper">
                  <img
                    class="search-error-img"
                    src="@/assets/file-manager/search-icon-error.svg"
                    alt="Arquivos ou pastas não encontrados"
                  />
                  <h5 class="search-error-text-h5">
                    Nenhum arquivo ou pasta corresponde a esta pesquisa.
                  </h5>
                  <p class="text-regular">
                    Por favor, faça uma nova pesquisa utilizando outro termo.
                  </p>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <b-modal
          id="id-thumbnail-modal"
          centered
          size="lg"
          :hide-footer="true"
          ref="thumbnailModal"
          modal-class="m-thumb-preview-container"
          content-class="m-thumb-preview-content"
          header-class="m-thumb-preview-header"
          body-class="m-thumb-preview-body"
        >
          <b-img
            center
            :src="fileSelected.signURL"
            class="m-thumb-preview-img"
          ></b-img>
          <div class="m-thumb-preview-footer">
            <div class="m-thumb-preview-title">
              {{ fileSelected.file_name }}
            </div>
            <div>
              <img
                width="20px"
                src="@/assets/download-white.svg"
                class="m-thumb-preview-download-image"
              />
              <a
                @click="callZipFiles(fileSelected)"
                class="m-thumb-preview-btn-download"
                download
                >Download</a
              >
            </div>
          </div>
        </b-modal>

        <pagination
          v-show="files.length > 10"
          :collection="files"
          @changedPage="getPagedCollection"
        ></pagination>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FileManagerApi from '@/services/fileManager';
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/utils/Pagination';
import { getStringFromDate } from '@/utils/dateUtils';
import { truncateString } from '@/utils/stringUtils';
import zipFiles from '@/services/zipFiles';
import Tracker from '@/services/tracker';

import InputSearch from '@/components/form/InputSearch';

export default {
  name: 'FileManager',
  data: () => ({
    fileSelected: { title: '', thumbnail: '' },
    advertiser: {},
    fields: [
      { name: 'Nome' },
      { name: 'Modificado' },
      { name: 'Tamanho' },
      { name: 'Baixar' },
    ],
    files: [],
    breadcrumbCollection: [],
    breadCrumbSession: 'pag.material.breadcrumb',
    folderCode: '',
    pagedFiles: [],
    showSearchError: false,
  }),
  components: {
    Breadcrumb,
    Pagination,
    InputSearch,
  },
  async created() {
    await this.fetchAdvertisers();
    const curretBread = sessionStorage.getItem(this.breadCrumbSession);
    this.folderCode = this.$route.params.folderCode;
    const { activeAd } = this;
    this.advertiser = activeAd.filter(
      advertiser => advertiser.code === this.$route.params.code.toString(),
    );
    if (!curretBread || curretBread.length === 0 || !this.folderCode) {
      this.initBreadCrumb();
    } else {
      this.breadcrumbCollection = JSON.parse(
        sessionStorage.getItem(this.breadCrumbSession),
      );
    }
    if (this.folderCode) {
      this.startLoading();
      await this.loadByIdtParent(this.folderCode);
      this.stopLoading();
    } else {
      this.startLoading();
      await this.loadByProduct();
      this.stopLoading();
    }
  },
  computed: {
    ...mapGetters({ activeAd: 'activeAdvertisers', itsLoading: 'itsLoading' }),
    baseUrlFolder() {
      return `/campanha/${this.advertiser[0].code}/material-de-apoio/`;
    },
    getFolderTittle() {
      if (this.breadcrumbCollection.length > 0) {
        const title = this.breadcrumbCollection
          ? this.breadcrumbCollection[this.breadcrumbCollection.length - 1].name
          : '';
        if (title === 'Material de apoio') {
          return ' ';
        }
        return ` - ${title}`;
      }

      return '';
    },
  },
  methods: {
    ...mapActions(['fetchAdvertisers', 'startLoading', 'stopLoading']),
    initBreadCrumb() {
      const bread = [
        { name: 'Campanhas', url: '/campanhas' },
        {
          name: this.advertiser[0].name,
          url: `/campanha/${this.advertiser[0].code}`,
        },
        {
          name: 'Material de apoio',
          url: `/campanha/${this.advertiser[0].code}/material-de-apoio`,
        },
      ];
      this.breadcrumbCollection.push(...bread);
      sessionStorage.setItem(this.breadCrumbSession, JSON.stringify(bread));
    },
    async loadByProduct() {
      const idtProduct = this.advertiser[0].id;
      const { folders } = await FileManagerApi.getFoldersByIdtProductSource(
        idtProduct,
      );
      this.files.push(...folders);
    },
    async loadByIdtParent(idt) {
      const { folders, files } = await FileManagerApi.getFoldersAndFilesByIdtParent(idt);
      this.files = [];
      this.files.push(...folders);
      this.files.push(...files);
    },
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    getImgUrl(ext) {
      const images = require.context('@/assets/file_types/', false, /\.svg$/);
      const extensions = ['html', 'mp4', 'pdf', 'ppt', 'txt', 'zip'];
      const extImages = ['png', 'jpg'];
      if (extImages.indexOf(ext) !== -1) return '';
      if (extensions.indexOf(ext) !== -1) {
        return images(`./${ext}.svg`);
      }
      return images('./default.svg');
    },
    setBreadCrumb(breadName, breadIdt) {
      const bread = {
        name: breadName,
        url: `/campanha/${this.advertiser[0].code}/material-de-apoio/${breadName}/${breadIdt}`,
        idt: breadIdt,
      };
      const breadCrumb = JSON.parse(
        sessionStorage.getItem(this.breadCrumbSession),
      );
      breadCrumb.push(bread);
      sessionStorage.setItem(
        this.breadCrumbSession,
        JSON.stringify(breadCrumb),
      );
      Tracker.track(`clicou pasta ${breadName} ${this.advertiser[0].code}`);
    },
    removeBreadCrumb(idt) {
      if (idt === null || idt === '') {
        return;
      }
      const currentBreadCrumb = JSON.parse(
        sessionStorage.getItem(this.breadCrumbSession),
      );
      const i = currentBreadCrumb.findIndex(b => b.folder === idt);
      if (i !== currentBreadCrumb.length) {
        currentBreadCrumb.splice(i, currentBreadCrumb.length);
        sessionStorage.setItem(
          this.breadCrumbSession,
          JSON.stringify(currentBreadCrumb),
        );
      }
    },
    getPagedCollection(pagedCollection) {
      this.pagedFiles = pagedCollection;
    },
    checkMobile(size) {
      return window.innerWidth <= size;
    },
    nameFormatter(name) {
      return truncateString(name, 18);
    },
    async searchFilesAndFolders(term) {
      const folderIdt = this.folderCode
        ? this.folderCode
        : this.files[0].parent_idt;
      const result = await FileManagerApi.getDirectoryByTerm(folderIdt, term);
      this.files = [];
      this.showSearchError = false;

      if (result.folders !== undefined && result.folders.length > 0) {
        this.files.push(...result.folders);
      }

      if (result.files !== undefined && result.files.length > 0) {
        this.files.push(...result.files);
      }

      if (!this.files.length > 0) {
        this.showSearchError = true;
      }
    },
    openThumbnailModal(file) {
      this.fileSelected = file;
      this.$refs.thumbnailModal.show();
      Tracker.track(`clicou arquivo ${file.file_name} ${this.advertiser[0].code}`);
    },
    async callZipFiles(file) {
      Tracker.track(`download ${file.file_name} ${this.advertiser[0].code}`);
      await zipFiles(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  color: $text-warning;
  background-color: $bg-light-grey;
}

.fields-th {
  padding-left: 0;
}

.fields-th:first-child {
  width: 60%;
}

.fields-th:nth-child(2),
.fields-th:nth-child(3) {
  width: 15%;
}

.click-preview {
  cursor: pointer;
}

.table-tr-files {
  td {
    .folder-icon {
      padding-right: 15px;
      @media (max-width: 768px) {
        padding-right: 10px;
      }
    }
  }
}

.download-icon {
  padding-right: 3px;
  height: 20px;
}

.download-link {
  color: #1082be;
  height: 35px;
  display: flex;
  align-items: center;
  span {
    color: #1082be;
  }
}

.tbody-files {
  border-top: 1px solid #cdcdcd;

  &.pagination {
    border-bottom: 1px solid #cdcdcd;
  }
}

.modificado-text {
  font-size: 12px;
  text-align: left;
}

.search-error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .search-error-img {
    padding: 20px 0;
  }
  .search-error-text-h5 {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .th-Modificado {
    display: none;
  }
  .th-tamanho,
  .th-baixar,
  .file-size,
  .file-download {
    text-align: center;
  }
  .file-size {
    padding-right: 0;
  }
  .download-icon {
    height: 25px;
  }
  .perpage-selector {
    padding-bottom: 20px;
  }
  .td-file-name-icon {
    line-height: 14px;
    padding-left: 0;
    padding-right: 0;
  }
  .file-name-icon {
    height: 22px;
  }

  #input-search-container {
    margin-top: 10px;
    width: 100%;
    float: right;
  }
}

@media (min-width: 768px) {
  .table-tr-files {
    td {
      padding: 0;
    }
  }

  #input-search-container {
    margin-top: 10px;
    width: 40%;
    float: right;
  }
}

.m-thumb-preview-footer,
.m-thumb-preview-footer > div {
  padding-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  .m-thumb-preview-title {
    width: 100%;
    margin-left: 20px;
    overflow: hidden;
  }

  .m-thumb-preview-btn-download {
    margin-right: 20px;
    cursor: pointer;
  }

  .m-thumb-preview-title,
  .m-thumb-preview-btn-download {
    color: white;
  }

  .m-thumb-preview-download-image {
    cursor: pointer;
  }
}

.m-thumb-preview-img {
  max-height: 500px;
  max-width: 100%;
  @media (max-width: 768px) {
    height: auto;
  }
}
</style>
